import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2, MailCheck, KeyRound } from "lucide-react";
import api, { formatApiErrorDetail } from "../lib/api";

function Marco({ children }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
      <div className="card bg-white p-8 w-full max-w-md">
        <img src="/img/farmanaliza-logo.png" alt="Farmanaliza" className="h-10 w-auto mb-6" />
        {children}
      </div>
    </div>
  );
}

export function Recuperar() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const [error, setError] = useState("");
  const enviar = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try { await api.post("/auth/forgot-password", { email }); setEnviado(true); }
    catch (err) { setError(formatApiErrorDetail(err.response?.data?.detail) || "No se pudo enviar. Inténtalo de nuevo."); }
    finally { setBusy(false); }
  };
  return (
    <Marco>
      {enviado ? (
        <div data-testid="recuperar-enviado">
          <MailCheck size={28} className="text-emerald-600 mb-2" />
          <h1 className="font-display text-2xl font-bold">Revisa tu correo</h1>
          <p className="text-sm text-slate-600 mt-2">Si {email} tiene cuenta en Farmanaliza, te hemos enviado un enlace para crear una contraseña nueva. Caduca en 1 hora. Mira también en la carpeta de spam.</p>
          <Link to="/login" className="btn btn-primary w-full justify-center mt-6" data-testid="recuperar-volver">Volver al acceso</Link>
        </div>
      ) : (
        <form onSubmit={enviar} className="space-y-4" data-testid="recuperar-form">
          <h1 className="font-display text-2xl font-bold">¿Has olvidado la contraseña?</h1>
          <p className="text-sm text-slate-600">Escribe el email de tu cuenta y te enviaremos un enlace para crear una nueva.</p>
          <input type="email" required className="input w-full" placeholder="tu@farmacia.es" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="recuperar-email" />
          {error && <div className="text-sm text-red-700 bg-red-50 px-3 py-2 rounded" data-testid="recuperar-error">{error}</div>}
          <button className="btn btn-primary w-full justify-center" disabled={busy} data-testid="recuperar-enviar">{busy ? <Loader2 size={16} className="animate-spin" /> : null} Enviar enlace</button>
          <Link to="/login" className="block text-center text-sm text-slate-500 hover:underline">Volver al acceso</Link>
        </form>
      )}
    </Marco>
  );
}

export function NuevaPassword() {
  const token = new URLSearchParams(window.location.search).get("token") || "";
  const [p1, setP1] = useState("");
  const [p2, setP2] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [hecho, setHecho] = useState(false);
  const navigate = useNavigate();
  const guardar = async (e) => {
    e.preventDefault();
    if (p1.length < 8) { setError("La contraseña debe tener al menos 8 caracteres."); return; }
    if (p1 !== p2) { setError("Las dos contraseñas no coinciden."); return; }
    setBusy(true); setError("");
    try { await api.post("/auth/reset-password", { token, new_password: p1 }); setHecho(true); setTimeout(() => navigate("/login"), 2500); }
    catch (err) { setError(formatApiErrorDetail(err.response?.data?.detail) || "No se pudo cambiar la contraseña."); }
    finally { setBusy(false); }
  };
  return (
    <Marco>
      {hecho ? (
        <div data-testid="nueva-password-ok">
          <KeyRound size={28} className="text-emerald-600 mb-2" />
          <h1 className="font-display text-2xl font-bold">Contraseña cambiada</h1>
          <p className="text-sm text-slate-600 mt-2">Ya puedes entrar con tu contraseña nueva. Te llevamos al acceso…</p>
        </div>
      ) : (
        <form onSubmit={guardar} className="space-y-4" data-testid="nueva-password-form">
          <h1 className="font-display text-2xl font-bold">Crea una contraseña nueva</h1>
          {!token && <div className="text-sm text-red-700 bg-red-50 px-3 py-2 rounded">Falta el enlace del correo. <Link to="/recuperar" className="underline">Pide uno nuevo</Link>.</div>}
          <input type="password" required className="input w-full" placeholder="Contraseña nueva (mín 8)" value={p1} onChange={(e) => { setP1(e.target.value); setError(""); }} data-testid="nueva-password-1" />
          <input type="password" required className="input w-full" placeholder="Repite la contraseña" value={p2} onChange={(e) => { setP2(e.target.value); setError(""); }} data-testid="nueva-password-2" />
          {error && <div className="text-sm text-red-700 bg-red-50 px-3 py-2 rounded" data-testid="nueva-password-error">{error} {error.includes("nuevo") && <Link to="/recuperar" className="underline">Pedir otro enlace</Link>}</div>}
          <button className="btn btn-primary w-full justify-center" disabled={busy || !token} data-testid="nueva-password-guardar">{busy ? <Loader2 size={16} className="animate-spin" /> : null} Guardar contraseña</button>
        </form>
      )}
    </Marco>
  );
}
